const tabs = {
  CyclesList: () => import('@/views/career/cycle/CyclesList'),
  Cycle: () => import('@/views/career/cycle/CycleTabs'),
  CycleAnnouncement: () => import('@/views/career/cycle/CycleAnnouncement')
}

const state = {
  currentCycleRegistrationTab: tabs.CyclesList,
  tabs
}

const mutations = {
  SET_TABS: (state, tab) => {
    state.currentCycleRegistrationTab = state.tabs[tab]
  }
}

const actions = {
  setCycleRegistrationTab({ commit }, tab) {
    commit('SET_TABS', tab)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
